import React from 'react';

const Trope6: React.FC = () => {
  return (
    <g className="prefix__trope-decor-6 prefix__trope-decor">
      <></>;
    </g>
  );
};

export default Trope6;
